import { useRef, useState } from 'react'
import { Button, Table, Checkbox } from 'antd'
import _ from 'lodash'
import cx from 'classnames'
import moment from 'moment'
import { ProposalSection, DirectoryInput, Toast, Loader, DatePicker, Tip } from '@vzmi/shp_shared_compo'
import { PROPOSAL_REVIEW_STATUS, PROPOSAL_TYPE, PROPOSAL_PHASE_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { excelToJSON } from '@vzmi/component_ec_nodejs_util/dist/lib/excelUtil'
import { COMMA } from '@vzmi/component_ec_nodejs_util/dist/lib/parserUtil'
import { safeAwait, httpHandler } from '@vzmi/component_ec_nodejs_util/dist/lib/FetchDataUtil'
import { FetchDataUtil } from '@vzmi/component_ec_nodejs_util/dist/lib'
import styles from './index.css'
import batchStyles from './BatchUploadImage.css'
import CommonPage from '../../containers/Proposal/Common/CommonPage'
import HeadingWithId from '../Proposal/Common/HeadingWithId/HeadingWithId'
import ProposalCompletion from '../Proposal/Common/ProposalCompletion/ProposalCompletion'
import UpdatedListingsTableCard from '../BatchProposal/Common/Card/UpdatedListingsTable'
import Feature from './Feature'
import { HyperLink, When } from '../Common/Form'
import { getISO8601UTC, DATE_FORMAT } from '../../lib/MomentHelper'
import { convertDateByMoment } from '../../../lib/renderUtil'
import {
  EXPORT_BATCH_UPDATE_IMAGE_HEADERS,
  INVERT_BOOLEAN_STRING,
  getUpdateImageExcelData,
  getLocalImagesFromExcelData,
  checkExcelData,
  exportExcel
} from '../Listing/QueryPage/exportBatchUpdateImageHelper'
import {
  getParamsList
} from './UpdateImage/helper'
import { UPDATE_IMAGE_V2 } from '../Proposal/UpdateListing/helpers/converters'
import errorHelper from '../../../lib/errorHelper'
import batchProposals, { BATCH_STATUS, batchProposalsAndUpdateStatus } from './request/batchProposals'
import { TOAST_DURATION } from '../../constants/proposalTypes'
import useS3Upload from '../../hooks/useS3Upload'
import { withI13nWrapper } from '../Common/I13nWrapper'
import useI13N from './hook/useI13N'
import { CDN } from '@vzmi/shp_shared_compo/dist/constants/cdn.js'

export const BATCH_PROPOSAL_TYPE = {
  EXECUTE: 'execute',
  REVERT: 'revert'
}
export const BATCH_TYPE_LIMIT_MAP = {
  [BATCH_PROPOSAL_TYPE.EXECUTE]: '最短可預約下 2 個小時，最長可預約提案日+1個月',
  [BATCH_PROPOSAL_TYPE.REVERT]: '須晚「預約執行時間」15分鐘，最短可預約下 3 個小時，最長可預約提案日 +2 個月'
}

const step1List = [
  (<>
    請先至
    <HyperLink
      href='/listing/query'
      target='_blank'
    >
      賣場查詢
    </HyperLink>
    查詢並匯出欲修改之賣場圖片資訊檔案 (xlsx檔案)，檔名可修改，但工作表名稱不可修改 (batchImage)。
  </>),
  'EXCEL 第一列是表頭，請勿將表頭刪除，一次上傳賣場不可超過200筆。',
  '灰底欄位為辨識用資訊，請勿調整。',
  '將欲修改之圖片欄位填入欲上傳的圖檔名稱（包含副檔名），若不修改之圖片，請維持原始檔案之圖檔連結文字。',
  '若移除該圖片連結，則該圖片將會從該賣場上移除。',
  '檔案上傳後，若成功送出提案，將立即執行並更新賣場。',
  (<>
    圖片相關規則：
    <ul
      key='img-rules'
      className={cx(styles.listing, batchStyles.subListing)}
    >
      <li>圖片上限：每個商品最多10張，必含2張主圖（1000x1000 px）</li>
      <li>圖片尺寸：均為1000x1000 px（建議）</li>
      <li>圖片格式：JPG、JPEG、PNG</li>
      <li>特別提醒：第2張主圖需為白底圖（去背），無浮水印/logo/鑲框/文字等修飾物件，以符合Google PLA規範，消費者可藉關鍵字搜尋到達賣場增加曝光。</li>
    </ul>
  </>),
  (<>
    相關說明：
    <HyperLink
      href={`${CDN}/img/batchImageUploadExcelFieldTips.png`}
      target='_blank'
    >
      欄位填寫說明
    </HyperLink>
    、
    <HyperLink
      href={`${CDN}/file/sample.xlsx`}
      target='_blank'
    >
      填寫範例
    </HyperLink>
    、
    <HyperLink
      href={`${CDN}/file/batchUploadImage-handbook-202407a.pdf`}
      target='_blank'
    >
      功能操作說明
    </HyperLink>
    。
  </>),
  (<span
    key='NewInfo'
    className={batchStyles.pink}
  >
    NEW! 可預約換圖！
    <ul
      key='new-info-dots'
      className={cx(styles.listing, batchStyles.subListing, batchStyles.pink)}
    >
      <li>由於提案和審核過程中會有時間差，可能造成賣場/商品圖片的舊圖和目前線上圖片已不相同，遇此情況系統仍會執行提案單內新圖的內容。</li>
      <li>預約換圖及自動回檔的時間僅代表系統批次開始執行的時間，不代表換圖/回檔執行完成的時間，最久大約10分鐘內可執行完成。(例如：預約10:00的換圖，將可預期最晚會在10:10前完成換圖)</li>
      <li>若設定自動回檔，將以提案當時賣場/商品之圖片進行回檔。</li>
    </ul>
  </span>)
]

const step2List = [
  (<>
    請先至
    <HyperLink
      href='/listing/query'
      target='_blank'
    >
      賣場查詢
    </HyperLink>
    查詢並匯出欲修改之賣場圖片資訊檔案 (xlsx檔案)，檔名可修改，但工作表名稱不可修改 (batchImage)。
  </>),
  '灰底欄位為辨識用資訊，請勿調整。'
]

const DatePickerOrReadOnly = ({ readOnly, value, ...rest }) => readOnly
  ? <div className={batchStyles.batchTime}>{convertDateByMoment(value, DATE_FORMAT.SCHEDULE)}</div>
  : <DatePicker {...{ value, ...rest }} />

const controller = new AbortController()

const BatchProposalMain = (props) => {
  const { actions: { fetchListings }, page, i13nMethods, currentStep, setCurrentStep, isAllsettled, setIsAllsettled } = props
  const [isLoading, setIsLoading] = useState(false)
  const refFolder = useRef()
  const excelRef = useRef()
  const {
    trigger,
    error: s3Error,
    result: uploadImageResult
  } = useS3Upload(props, validations)

  const [excelData, setExcelData] = useState({})
  const [checkedExcelData, setCheckedExcelData] = useState({})
  const [listings, setListings] = useState([])
  const [batchId, setBatchId] = useState(null)
  const [isWaitingRevert, setWaitingRevert] = useState(false)
  // move to next step and check excel data and upload images to s3
  const excelAnalysis = async () => {
    // check if schedule/revert time is set and valid
    if (isScheduled) {
      if (!executeTs) {
        return Toast.warn('請選擇預約執行時間')
      }
      const minMoment = moment().add(2, 'hours')
      const maxMoment = moment().add(30, 'days')
      if (
        executeTs.isBefore(minMoment) ||
        executeTs.isAfter(maxMoment)
      ) {
        return Toast.warn(`預約執行時間須在${BATCH_TYPE_LIMIT_MAP[BATCH_PROPOSAL_TYPE.EXECUTE]}內`)
      } else if (
        isRevert && executeTs.isAfter(revertTs)
      ) {
        return Toast.warn('預約執行時間不可晚於回檔時間')
      }
    }
    if (isRevert) {
      if (!revertTs) {
        return Toast.warn('請選擇回檔時間')
      }
      const minMoment = moment(executeTs).add(15, 'minutes')
      const minMoment2 = moment().add(3, 'hours')
      const maxMoment = moment().add(60, 'days')
      if (
        revertTs.isBefore(minMoment) ||
        revertTs.isBefore(minMoment2) ||
        revertTs.isAfter(maxMoment)
      ) {
        return Toast.warn(`回檔時間${BATCH_TYPE_LIMIT_MAP[BATCH_PROPOSAL_TYPE.REVERT]}`)
      }
    }

    setIsLoading(true)

    if (excelRef.current.files.length === 0) {
      Toast.warn('請選擇 EXCEL 檔案')
      setIsLoading(false)
      return
    }
    // get excel data
    const jsonData = await excelToJSON({ target: excelRef.current })
    const excelData = getUpdateImageExcelData(jsonData)
    setExcelData(excelData)

    // get listing Ids from excel data
    const id = _.flow(
      () => _.map(excelData, 'id'),
      ids => _.join(ids, COMMA)
    )()

    // get listings
    const params = { id, fields: '' }
    const [listingError, listingRes] = await safeAwait(
      FetchDataUtil.fetchAllPages(params => {
        return fetchListings(params)
          .then(res => {
            if (res.error) {
              throw res
            }
            return res
          })
      }, {
        payload: params,
        selector: res => _.get(res, 'listings', [])
      })
    )
    if (listingError) {
      setIsLoading(false)
      return
    }
    const listings = _.get(listingRes, 'data', [])
    setListings(listings)

    // check excel data
    const result = checkExcelData(excelData, listings)
    // checkedExcelData would be shown in ResultTable
    setCheckedExcelData(result)

    // skip upload image if there is any error
    if (_.isEmpty(result)) {
      const localImages = getLocalImagesFromExcelData(excelData)
      const files = refFolder.current.getFileListByNames(localImages)

      // check if local images are all in folder
      const isImagesNotExist = localImages.some(image => {
        if (!_.find(files, { name: image })) {
          Toast.error(`圖片資料匣內找不到 ${image}`, { duration: TOAST_DURATION })
          return true
        }
        return false
      })
      if (isImagesNotExist) {
        setIsLoading(false)
        return
      }

      // upload local images to s3
      const { error: s3Error } = await trigger(files || [])
      if (!_.isEmpty(s3Error)) {
        Toast.error(s3Error, { duration: TOAST_DURATION })
        setIsLoading(false)
        return
      }
    }
    setIsLoading(false)

    // move to next step
    setCurrentStep(2)
  }

  const [results, setResults] = useState({})
  // move to step 3 and post proposal
  const postProposal = async () => {
    setCurrentStep(3)

    // 1. 新增批次提案單 create batch proposal getting new batch id
    const [createBatchError, createBatchRes] = await safeAwait(
      props.actions.createBatchProposal({
        proposalType: 'updateImageV2',
        batchSource: 'excel',
        instantExecute: !isScheduled,
        ...isScheduled && { executeTs: getISO8601UTC(executeTs) },
        ...isRevert && { revertTs: getISO8601UTC(revertTs) }
      }).then(httpHandler)
    )
    const createBatchErrorMsg = errorHelper.parseErrorMessage(createBatchError)
    if (!_.isEmpty(createBatchErrorMsg)) {
      Toast.error(`無法建立批次提案單：${createBatchErrorMsg}`, { duration: TOAST_DURATION })
      return
    }
    const batchId = _.get(createBatchRes, 'id')
    setBatchId(batchId)

    // construct every singal proposal params
    const paramsList = getParamsList(
      {
        applicant: excelData[0].applicant,
        listings: listings.map(listing => {
          const { id } = listing
          const excelRowItem = _.find(excelData, { id: id.toString() })
          const isNoModelsListing = _.isEmpty(listing.models)
          const getModelImages = (model, index) => ({
            images: [
              // get excel fields `MainImages` and `Images` combined
              ..._.get(excelRowItem, `model${index + 1}MainImages`, '').split(COMMA),
              ..._.get(excelRowItem, `model${index + 1}Images`, '').split(COMMA)
            ]
              // filter array item contains empty string (from excel cell)
              .filter(item => item !== '')
              .map((url, index) => ({
                width: 1000,
                height: 1000,
                order: index + 1,
                // replace local image url with s3 url
                url: url.startsWith('http')
                  ? url
                  : uploadImageResult[url].url
              })),
            ...model.sku ? { sku: model.sku } : {}
          })

          return {
            ..._.pick(listing, ['id', 'shareMediaBetweenModels', 'swCode']),
            ...isNoModelsListing
              ? { isNoModelsListing, models: [getModelImages({}, 0)] }
              : { models: listing.models.map(getModelImages) }
          }
        })
      },
      // reviewStatus: 預約執行和回檔的送 draft, 立刻執行的送 pendingReview
      isScheduled
        ? PROPOSAL_REVIEW_STATUS.DRAFT
        : PROPOSAL_REVIEW_STATUS.PENDING_REVIEW,
      []
    )

    // pre setState all proposals with params
    setResults(_.reduce(paramsList, (collect, params, index) => {
      collect[index] = { params }
      return collect
    }
    , {}))

    // start post proposals and handle result with concurrency using chunk
    const { signal } = controller
    const concurrency = 5
    const chunkParamsList = _.chunk(paramsList, concurrency)
    let chunkedIndex = 0
    const postProposalsRes = {}
    for (const chunkParams of chunkParamsList) {
      await Promise.all(
        chunkParams.map((chunkParam, index) => (
          batchProposalsAndUpdateStatus(
            props.actions,
            {
              ...chunkParam,
              // 2. 把新增拿到的批次編號放到修改圖片提案的 payload 裡做新增修改圖片提案
              batch: {
                id: batchId,
                type: BATCH_PROPOSAL_TYPE.EXECUTE
              }
            },
            chunkedIndex * concurrency + index,
            setResults,
            signal
          ).then(([error, payload]) => {
            // save the result for updating batch proposal details
            setResults((prevState) => ({
              ...prevState,
              [chunkedIndex * concurrency + index]: {
                ...prevState[chunkedIndex * concurrency + index],
                [BATCH_PROPOSAL_TYPE.EXECUTE]: payload.id
              }
            }))
            postProposalsRes[chunkedIndex * concurrency + index] = payload
            return [error, payload]
          })
        ))
      ).then(() => {
        // 若按下「中斷上傳」按鈕，則顯示完成頁
        if (signal.aborted) {
          setIsAllsettled(true)
          throw new Error('abort upload batch proposals')
        }
      })
      chunkedIndex = chunkedIndex + 1
    }

    // 回檔提案
    if (isRevert) {
      const revertParamsList = listings.map(({ models, ...restListing }) => {
        const { shareMediaBetweenModels } = restListing
        return {
          listing: {
            ..._.pick(restListing, ['id', 'shareMediaBetweenModels', 'swCode', 'images']),
            ...models
              ? {
                models: shareMediaBetweenModels
                  ? [_.first(models)] // 共用商品圖只用第一個 model
                  : models.map(model => _.pick(model, ['sku', 'images']))
              }
              : {}
          },
          reviewStatus: PROPOSAL_REVIEW_STATUS.DRAFT,
          applicant: excelData[0].applicant,
          type: UPDATE_IMAGE_V2,
          batch: {
            id: batchId,
            type: BATCH_PROPOSAL_TYPE.REVERT
          }
        }
      })

      setWaitingRevert(true)
      await batchProposals(
        props.actions,
        revertParamsList
      ).then(batchResult => {
        // save id of result for revertProposalId for updating batch proposal details
        batchResult.forEach(([eachPrposalError, eachProposalRes], index) => {
          const { id: revertProposalId } = eachProposalRes
          setResults((prevState) => ({
            ...prevState,
            [index]: {
              ...prevState[index],
              revertProposalId
            }
          }))
          postProposalsRes[index].revertProposalId = revertProposalId
        })
      })
    }

    // 3. 更新批次提案單 (把修改圖片提案加到批次的 details)
    const [updateBatchError] = await safeAwait(
      props.actions.updateBatchProposal({
        id: batchId,
        // loop postProposalsRes{} to get details[]
        details: Object.values(postProposalsRes)
          // 為了避免上傳失敗的單一提案影響整個批次提案，在更新批次提案前，只準備成功的提案
          .filter(
            result => _.get(result, 'listing.id') &&
            (isRevert ? result.revertProposalId : true)
          )
          .map(result => ({
            listingId: result.listing.id,
            executeProposalId: result.id,
            ...isRevert && { revertProposalId: result.revertProposalId }
          }))
      }).then(httpHandler)
    )
    if (updateBatchError) {
      Toast.error(errorHelper.parseErrorMessage(updateBatchError), { duration: TOAST_DURATION })
    }

    // 可顯示完成頁
    setIsAllsettled(true)
  }

  const downloadFailedListings = async () => {
    setIsLoading(true)
    const listingMapById = _.keyBy(listings, 'id')
    const excelDataMapByListingId = _.keyBy(excelData, 'id')
    const rejectedListings = _.flow(
      () => _.values(results),
      // 從結果中找出全部不成功的表格列，即包含中斷、未發送
      resultValues => _.filter(resultValues, resultValue => resultValue.status !== BATCH_STATUS.FULFILLED),
      rejectedResultValues => {
        // 失敗列以賣場編號組成對應表
        const rejectedListingIdMap = _.keyBy(rejectedResultValues, 'params.listing.id')
        return _.reduce(rejectedResultValues, (collect, rejectedResultValue) => {
          const listingId = _.get(rejectedResultValue, 'params.listing.id')
          const {
            models: editedModels,
            images: editedImages
          } = _.get(rejectedListingIdMap, `${listingId}.params.listing`, {})
          // excel 資料重新轉換成賣場資料(是 > true)
          const listingFieldFromExcel = _.flow(
            () => _.get(excelDataMapByListingId, listingId, {}),
            excelListing => _.pick(excelListing, ['id', 'name', 'shareMediaBetweenModels', 'syncProductImages', 'model1Sku']),
            pickedExcelListing => _.reduce(pickedExcelListing, (obj, value, key) => {
              const convertedValue = _.get(INVERT_BOOLEAN_STRING, value, value)
              obj[key] = convertedValue
              return obj
            }, {})
          )()
          // [有屬性]從賣場編號取得對應修改前賣場資料
          const listing = _.get(listingMapById, listingId, {})
          const listingModelsWithEdited = editedModels && _.map(editedModels, (editedModel, index) => {
            const listingModel = _.get(listing, `models[${index}]`, {})
            return { ...listingModel, ...editedModel }
          })
          // [無屬性]從賣場編號取得對應修改前賣場資料
          const listingImagesWithEdited = editedImages && _.map(editedImages, (editedImage, index) => {
            const listingImage = _.get(listing, `images[${index}]`, {})
            return { ...listingImage, ...editedImage }
          })
          // 匯出失敗資料組成 (excel 資料、商品資料以原始賣場商品資料加上修改內容)
          collect.push({
            ...listingFieldFromExcel,
            ...listingModelsWithEdited ? { models: listingModelsWithEdited } : {},
            ...listingImagesWithEdited ? { images: listingImagesWithEdited, sku: listingFieldFromExcel.model1Sku } : {}
          })
          return collect
        }, [])
      }
    )()
    // 無失敗賣場不匯出 excel
    if (_.isEmpty(rejectedListings)) {
      Toast.info('沒有修改失敗的賣場')
      setIsLoading(false)
      return
    }

    const applicant = _.get(page, 'user.identity.name', '')
    const [exportError] = await safeAwait(exportExcel(rejectedListings, applicant, '失敗'))
    if (exportError) {
      Toast.error(exportError, { duration: TOAST_DURATION })
    }
    setIsLoading(false)
  }

  const [isScheduled, setIsScheduled] = useState(false) // 是否預約提案
  const [executeTs, setExecuteTs] = useState(null) // 預約執行時間
  const [isRevert, setIsRevert] = useState(false) // 是否回檔提案
  const [revertTs, setRevertTs] = useState(null) // 回檔時間

  const SchedulControl = ({ readOnly }) => (
    <div className={batchStyles.uploaderLabel}>
      <Checkbox
        onClick={() => setIsScheduled(!isScheduled)}
        checked={isScheduled}
        disabled={readOnly}
        className={batchStyles.checkbox}
      >
        預約修改圖片提案執行時間
      </Checkbox>
      <When
        value={isScheduled}
        isTrue
      >
        <DatePickerOrReadOnly
          showTime
          placeholder='選擇預約執行時間'
          format={DATE_FORMAT.SCHEDULE}
          disabledDate={current => {
            if (current) {
              return current < moment().startOf('day') || current > moment().add(30, 'days')
            }
            return false
          }}
          value={executeTs}
          onChange={value => setExecuteTs(value)}
          readOnly={readOnly}
        />
        <Tip
          type='info'
          className={batchStyles.uploaderLabel}
        >
          {BATCH_TYPE_LIMIT_MAP[BATCH_PROPOSAL_TYPE.EXECUTE]}
        </Tip>
        <Checkbox
          onClick={() => setIsRevert(!isRevert)}
          checked={isRevert}
          disabled={readOnly}
          className={batchStyles.checkbox}
        >
          設定自動回檔
        </Checkbox>
        <When
          value={isRevert}
          isTrue
        >
          <DatePickerOrReadOnly
            showTime
            placeholder='選擇回檔時間'
            format={DATE_FORMAT.SCHEDULE}
            disabledDate={current => {
              if (current) {
                return current < moment().startOf('day') || current > moment().add(60, 'days')
              }
              return false
            }}
            value={revertTs}
            onChange={value => setRevertTs(value)}
            readOnly={readOnly}
          />
          <Tip type='info'>
            以現在賣場圖片進行回檔；
            {BATCH_TYPE_LIMIT_MAP[BATCH_PROPOSAL_TYPE.REVERT]}
          </Tip>
        </When>
      </When>
    </div>
  )

  // 在三步驟各加上 GA 紀錄
  const i13nData = {
    proposalType: PROPOSAL_TYPE.UPDATE_IMAGE,
    queryStringListingIds: listings.map(listing => listing.id).join(COMMA),
    /**
     * reservation: 是否預約修改與回復
     * 0: no
     * 1: 預約修改
     * 2: 預約修改 & 回復
     */
    ...currentStep !== 1
      ? {
        reservation: isScheduled && isRevert
          ? '2'
          : isScheduled
            ? '1'
            : '0'
      }
      : {}
  }
  const pageFlow = {
    isEditPage: currentStep === 1,
    isConfirmPage: currentStep === 2,
    isSuccessPage: currentStep === 3
  }
  useI13N(i13nMethods, i13nData, pageFlow, 'batchUpload')

  return (
    <div className={cx(styles.topContainer, isAllsettled ? batchStyles.noPadding : {})}>
      { /* 上傳完成或上傳中斷前才顯示 */ !isAllsettled
        ? (
          <>
            <HeadingWithId
              title='批次修改賣場/商品圖案 - 上傳檔案'
              data-role='batch-uplooadImages-header'
            />
            <ProposalSection
              title='操作說明'
              className={styles.proposalSection}
            >
              <Feature content={step1List} />
            </ProposalSection>
            <ProposalSection
              title='Step1 匯出檔案'
              className={styles.proposalSection}
            >
              <Feature content={step2List} />
            </ProposalSection>
            <ProposalSection
              title='Step2 上傳檔案'
              className={cx(styles.proposalSection, batchStyles.batchUpload)}
            >
              <Loader loaded={!isLoading}>
                <div className={cx(styles.container, batchStyles.container)}>
                  <StepIndicator
                    currentStep={currentStep}
                    className={batchStyles.stepIndicator}
                    stepList={['匯入賣場圖片資料', '預覽/修正檔案', '上傳檔案']}
                  />
                  { currentStep === 1
                    ? (
                      <>
                        <label className={batchStyles.uploaderLabel}>
                          選擇 EXCEL 檔案
                          <input
                            type='file'
                            accept='.xlsx'
                            className={batchStyles.fileInput}
                            ref={excelRef}
                          />
                        </label>
                        <label className={batchStyles.uploaderLabel}>
                          選擇圖片資料匣
                          <DirectoryInput
                            ref={refFolder}
                          />
                        </label>
                        <SchedulControl />
                        <Button
                          type='primary'
                          size='large'
                          onClick={excelAnalysis}
                          disabled={isLoading}
                        >
                          匯入賣場圖片資料
                        </Button>
                      </>
                    )
                    : (
                      <>
                        {
                          !_.isEmpty(checkedExcelData)
                            ? (
                              <label className={batchStyles.red}>請修正檔案後再上傳</label>
                            )
                            : !_.isEmpty(s3Error)
                              ? (
                                <label className={batchStyles.red}>
                                  圖片上傳失敗：
                                  {s3Error}
                                </label>
                              )
                              : currentStep === 2 &&
                                (<label className={cx(batchStyles.green, batchStyles.biggerFont)}>檔案格式正確，請點擊下方「上傳檔案」送出提案</label>)
                        }
                        {(currentStep !== 3)
                          ? (
                            <ResultTable
                              excelData={excelData}
                              checkedExcelData={checkedExcelData}
                              currentStep={currentStep}
                              results={results}
                              abortController={controller}
                            />
                          )
                          : (
                            <label className={cx(batchStyles.green, batchStyles.biggerFont, batchStyles.uploaderLabel)}>
                              <Loader />
                              {isWaitingRevert
                                ? '回檔處理中...'
                                : (
                                  <>
                                    上傳中... (
                                    {Object.values(results).filter(result => result.status && result.status !== BATCH_STATUS.PENDING).length}
                                    /
                                    {Object.keys(excelData).length}
                                    )
                                  </>
                                )
                              }
                            </label>
                          )
                        }
                        {/* --- action buttons --- */}
                        { currentStep === 2 && (
                          <>
                            <SchedulControl readOnly />
                            <Button
                              type='primary'
                              size='large'
                              disabled={isLoading || !_.isEmpty(checkedExcelData) || !_.isEmpty(s3Error)}
                              onClick={postProposal}
                            >
                              上傳檔案
                            </Button>
                            <Button
                              type='default'
                              size='large'
                              onClick={() => setCurrentStep(1)}
                            >
                              返回
                            </Button>
                          </>
                        )}
                        { currentStep === 3 && (
                          <Button
                            type='primary'
                            size='large'
                            disabled={controller.signal.aborted}
                            onClick={() => controller.abort()}
                          >
                            中斷上傳
                          </Button>
                        )
                        }
                      </>
                    )}
                </div>
              </Loader>
            </ProposalSection>
          </>
        )
        : (/* 上傳完成或上傳中斷(最後畫面)顯示 */
          <div className={batchStyles.container}>
            <UpdatedListingsTableCard
              batchLink={getBatchProposalLink(batchId, BATCH_PROPOSAL_TYPE.EXECUTE)}
              size={_.size(excelData)}
              className={batchStyles.updatedListingsTableCard}
              proposalTypePrefix='修改圖片'
              proposalTypeSuffix={executeTs
                ? `(執行時間：${moment(executeTs).format('YYYY/MM/DD HH:mm')})`
                : ''}
              noActions
            >
              <ResultTable
                excelData={excelData}
                currentStep={currentStep}
                results={results}
                abortController={controller}
              />
            </UpdatedListingsTableCard>
            <When
              value={isRevert}
              isTrue
            >
              <UpdatedListingsTableCard
                batchLink={getBatchProposalLink(batchId, BATCH_PROPOSAL_TYPE.REVERT)}
                size={_.size(excelData)}
                className={batchStyles.updatedListingsTableCard}
                proposalTypePrefix='回檔'
                proposalTypeSuffix={`(執行時間：${moment(revertTs).format('YYYY/MM/DD HH:mm')})`}
                noActions
              >
                <ResultTable
                  excelData={excelData}
                  currentStep={currentStep}
                  results={results}
                  abortController={controller}
                  isRevert
                />
              </UpdatedListingsTableCard>
            </When>
            <div className={batchStyles.finalActions}>
              <HyperLink
                target='_blank'
                href={window.location.href}
                className={batchStyles.newPageBtn}
                isButton
              >
                <Button
                  type='primary'
                  size='large'
                >
                  繼續上傳檔案
                </Button>
              </HyperLink>
              <Button
                type='default'
                size='large'
                onClick={downloadFailedListings}
                disabled={
                  Object.values(results).every(result => result.status === BATCH_STATUS.FULFILLED)
                }
              >
                下載失敗檔案
              </Button>
            </div>
          </div>
        )}
    </div>
  )
}

const StepIndicator = ({ currentStep, className, stepList }) => (
  <div className={className}>
    {stepList.map((step, index) => (
      <span
        key={index}
        data-role={currentStep === index + 1 ? 'active-step' : null}
      >
        {step}
      </span>
    ))}
  </div>
)

const validations = async (file) => {
  const fileName = file.name
  const isSizeCorrect = await new Promise(resolve => {
    const reader = new FileReader()
    reader.onload = event => {
      const img = new Image()
      img.onload = () => resolve(img.height === 1000 && img.width === 1000)
      img.src = event.target.result
    }
    reader.readAsDataURL(file)
  })
  if (!isSizeCorrect) {
    return { fileName, message: '圖片尺寸不符合' }
  }

  return {}
}

/**
 * generate batch proposal overview page link
 * @param {string} batchId batch id
 * @param {string} type batch proposal type, execute or revert
 * @returns {string} batch proposal link
 */
export const getBatchProposalLink = (batchId, type) => `/batchUpload/${PROPOSAL_TYPE.UPDATE_IMAGE}/${PROPOSAL_PHASE_TYPE.OVERVIEW}?id=${batchId}&type=${type}`

export const getProposalLink = id => `/proposal/${PROPOSAL_TYPE.UPDATE_IMAGE}/${PROPOSAL_PHASE_TYPE.OVERVIEW}?id=${id}`

const ResultTable = ({ excelData, checkedExcelData = {}, currentStep, results, abortController, isRevert }) => (
  <div
    className={batchStyles.tableWrapper}
    data-currentStep={currentStep}
  >
    <Table
      dataSource={excelData}
      columns={[
        // present excel row number
        { title: '', render: (text, record, index) => `列${index + 1}` },
        {
          title: currentStep === 2 ? '檔案檢查結果' : '送出提案結果',
          dataIndex: 'status',
          render: (text, record, index) => {
            const rowCheckResult = checkedExcelData[index]
            const rowProposalResult = results[index]
            const rowProposalId = isRevert
              ? rowProposalResult.revertProposalId
              : _.get(rowProposalResult, 'payload.id')
            return (
              <>
                {
                  // excel 與圖片檢查結果有錯誤時列出紅字訊息
                  rowCheckResult
                    ? Object.entries(rowCheckResult.field).map(([key, value]) => (
                      <div
                        key={key}
                        className={batchStyles.red}
                      >
                        {value}
                      </div>
                    ))
                    : currentStep === 2
                      ? (
                        <span className={batchStyles.green}>格式正確</span>
                      )
                      // 提案送出或結果
                      : !rowProposalResult || !rowProposalResult.status
                        ? abortController.signal.aborted
                          ? '已取消'
                          : '準備中'
                        : rowProposalResult.status === BATCH_STATUS.PENDING
                          ? (<span className={batchStyles.green}>提案送出中</span>)
                          : rowProposalResult.status === BATCH_STATUS.FULFILLED
                            ? (
                              <>
                                <span className={batchStyles.green}>提案送出成功</span>
                                ，提案編號
                                <HyperLink
                                  target='_blank'
                                  href={getProposalLink(rowProposalId)}
                                >
                                  {rowProposalId}
                                </HyperLink>
                              </>
                            )
                            : (
                              <span className={batchStyles.red}>
                                失敗，
                                {rowProposalResult.message}
                              </span>
                            )
                }
              </>
            )
          }
        },
        ...Object.entries(EXPORT_BATCH_UPDATE_IMAGE_HEADERS).map(([key, value]) => ({
          title: value,
          dataIndex: key
        }))
      ]}
      pagination={false}
    />
  </div>
)

const BatchUploadImage = props => {
  const [currentStep, setCurrentStep] = useState(1)
  const [isAllsettled, setIsAllsettled] = useState(false)
  const title = (
    <>
      批次修改圖片-上傳檔案：
      {controller.signal.aborted
        ? (<span className={cx(batchStyles.red, batchStyles.biggerFont)}>上傳中斷</span>)
        : (<span className={cx(batchStyles.green, batchStyles.biggerFont)}>上傳完成</span>)}
    </>
  )
  return (
    <CommonPage >
      { currentStep === 3 && isAllsettled && (
        <ProposalCompletion
          title={title}
          withHint={false}
        />
      )}
      <BatchProposalMain
        { ...({
          currentStep,
          setCurrentStep,
          isAllsettled,
          setIsAllsettled,
          ...props
        })}
      />
    </CommonPage>
  )
}

const hoc = component => withI13nWrapper(component)

export default hoc(BatchUploadImage)
